/**
 * =========================================================================================
 * Side Modal and Modal Popup
 * =========================================================================================
 **/

import React, {useEffect, useRef, useState} from 'react';
import * as Icon from 'ubs-icons';
import Popup from "reactjs-popup";
import PropTypes from 'prop-types';
import { COLOR } from '../common/constant';
import { isMobileDevice} from "../common/function";
import useEscKey from "ubs-framework/v2/hooks/useEscKey";
import useResizeHeight from '../hooks/useResizeHeight';
import useWindowSize from '../hooks/useWindowSize';

const SideModal = React.memo((props) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const size = useWindowSize();

    useEscKey(() => {
        if (props?.open && !document.querySelector('.react-datepicker-popper')) props.onClose();
    });

    const scrollHeight = useResizeHeight(['u_side-modal-header', 'u_side-modal-footer']);

    useEffect(() => {
        setTimeout(() => {
            setOpen(true);
            window.dispatchEvent(new Event('resize'));
        }, 10);

        if (props?.open && isMobileDevice() && size <= 1024) {
            document.querySelector('body').style.position = 'fixed';
            document.querySelector('body').classList.add('u_w-full');
            if(document.querySelector('.u_settings-left-sidebar .u_content-header')) { document.querySelector('.u_settings-left-sidebar .u_content-header').style.zIndex = 0; }
        }

        return (() => {
            document.querySelector('body').style.position = '';
            document.querySelector('body').classList.remove('u_w-full');
            if(document.querySelector('.u_settings-left-sidebar .u_content-header')) { document.querySelector('.u_settings-left-sidebar .u_content-header').removeAttribute("style"); }
        });
    }, [props?.open]);

    const handleClose = () => {
        setTimeout(() => setOpen(false), 10);
        props.onClose();
    };

    const setHeight = (scrollHeightTotal) => {
        let bodyHeight = window.innerHeight < 768 ? window.innerHeight : 700;
        return {maxHeight: props?.customHeight ? `calc(${bodyHeight}px - ${scrollHeightTotal}px)` : `100%`}
    }
    const overlayClick = () => {
        if (props.closeOnOutsideClick) handleClose()
    }

    return (
        <React.Fragment>
            <Popup
                open={props.open}
                onClose={props.onClose}
                modal
                contentStyle={{zIndex: props?.zIndex}}
                overlayStyle={{zIndex: props?.zIndex}}
                closeOnDocumentClick={props?.closeOnDocumentClick}
            >
                <div
                    ref={ref}
                    className={`u_side-modal ${open ? 'active' : ''} ${props?.className ? props?.className : ''}`}
                >
                    {/* Modal Overlay */}
                    {open && <div className="u_modal-overlay" onClick={overlayClick}/>}

                    {/* Modal Content */}
                    <div className={`u_side-modal-layout ${props.fullScreen ? 'u_side-modal-full-screen' : ''}`}  style={{maxWidth: `${props.maxWidth}px`}}>

                        {/* Modal header */}
                        <div className="u_side-modal-header u_flex u_align-center u_content-between" id="u_side-modal-header">
                            <div className="u_task-header-left">
                                {
                                    props?.header ?
                                        props?.header
                                        :
                                        <h6 className="u_one-line u_task-darkname test">{props.name}</h6>
                                }
                            </div>

                            <div className="u_task-header-right u_flex u_align-center">
                                <div className="u_close-btn__blue" onClick={handleClose}>
                                    <Icon.Close size={14} fill={COLOR.u_blue}/>
                                </div>
                            </div>
                        </div>

                        {/* Modal body */}
                        <div className="u_side-modal-body " id="u_side-modal-body" style={setHeight(scrollHeight)}>
                            {props.children}
                        </div>

                        {/* Modal footer */}
                        <div className="u_side-modal-footer" id="u_side-modal-footer">
                            {props.footer}
                        </div>

                    </div>
                </div>
            </Popup>
        </React.Fragment>
    );
})

SideModal.propTypes = {
    open: PropTypes.bool,
    name: PropTypes.string.isRequired,
    maxWidth: PropTypes.number,
    onClose: PropTypes.func.isRequired,
    footer: PropTypes.element,
    headerOptions: PropTypes.element,
    closeOnOutsideClick: PropTypes.bool,
    closeOnDocumentClick: PropTypes.bool,
    customHeight: PropTypes.bool,
    fullscreen: PropTypes.bool,
};

SideModal.defaultProps = {
    closeOnOutsideClick: false,
    closeOnDocumentClick: true,
    customHeight: true,
    fullscreen: false,
    zIndex: 1001
};

export default SideModal;
